<template>
  <div class="work">
    <h1>Work Experience</h1>
    <ExperienceData
      style="animation: none;"
      :data="`Jan 2024 — Sep 2025`"
      :position="`Frontend Developer at Mentat`"
      :text="`Worked as a Frontend Developer on the Gulp web UI — a React and TypeScript application. Developed and maintained UI components using Shadcn/UI, implemented user authentication screens, session management, and operation workflows. Engineered a high-performance real-time rendering system capable of processing 15,000+ events simultaneously using Canvas API and custom-built algorithms, significantly improving UI responsiveness under heavy load. Integrated and worked with LLMs, contributing to decisions on AI model selection and training approaches. Actively influenced team-wide architectural decisions, advising on optimal tech stack choices. Focused on creating responsive, modular, and high-performance interfaces, integrating with backend APIs, and improving overall usability and developer experience.`"
    />
    <ExperienceData
      :data="`Sep 2025 — Apr 2026`"
      :position="`Full-Stack Developer at NDA`"
      :text="`Worked on high-load systems and big data solutions as a full-stack developer. Tech stack included Next.js, TypeScript, Node.js, gRPC, tRPC, ConnectRPC, and AWS S3. Project details are strictly confidential under NDA.`"
    />
    <router-link to="/about">
      <UiButton 
        text="View More" 
        :hoverColor="`hsl(275, 80%, 71%)`" 
        :hoverBgColor="`hsl(281, 38%, 16%)`" 
      />
    </router-link>
  </div>
</template>

<script>
import ExperienceData from './component/experience.vue';
import UiButton from '@/ui/btn.vue';

export default {
  name: 'WorkExperience',
  components: {
    ExperienceData,
    UiButton
  }
}
</script>

<style scoped>
.work {
  width: 80%;
  display: flex;
  align-items: start;
  justify-content: center;
  flex-direction: column;
  padding: 5rem 0;
  gap: 2rem;
}
</style>
